import { ExtendedPresence } from './models/extended-presence.model';

export interface GenesysCloudPresenceState {
  presences: ExtendedPresence[];
  active?: ExtendedPresence;
}

export const initialState = (): GenesysCloudPresenceState => ({
  presences: []
});
